import { cva } from '@/styled-system/css';

export const progressTrackRecipe = cva({
  base: {
    position: 'absolute',
    inset: 0,
    backgroundColor: 'ProgressIndicator.bar.track.bg.default',
    zIndex: '1',
  },
  variants: {
    size: {
      md: {
        borderRadius: 'ProgressIndicator.bar.md',
      },
      sm: {
        borderRadius: 'ProgressIndicator.bar.sm',
      },
    },
  },
});
